module.exports = __webpack_public_path__ + "static/img/dkwps2-8.993deff.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwps2-8.png
// module id = 407
// module chunks = 0